import * as React from 'react';
import { connect } from 'react-redux';

import * as Actions from '../actions';
import Alert, { AlertCategoryEnum } from '../../../misc/components/Alert';
import { AnalyseState } from '../interfaces/state';
import { useCoughMarshalApiClient } from '../../../misc/api/CoughMarshalApiClient';
import { useWebPortalApiClient } from '../../../misc/api/WebPortalTokenClient';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export interface ResumePlaybackProps {
    hasBeenPreviouslyPlayed: boolean;

    dispatch?: any;
}

export const ResumePlayback = (props: ResumePlaybackProps) => {
    const coughMarshalClient = useCoughMarshalApiClient();
    const client = useWebPortalApiClient();

    return (
        <Alert show={props.hasBeenPreviouslyPlayed} category={AlertCategoryEnum.Info}>
            <FontAwesomeIcon icon={faInfoCircle} className="icon fa-fw" aria-hidden="true" />
            This recording has been previously played would you like to resume playback? <a onClick={() => props.dispatch(Actions.ResumePlaybackAsyncAction.create(coughMarshalClient, client))}>Resume</a>
        </Alert>
    );
}

function mapStateToProps(state: AnalyseState) {
    return {
        hasBeenPreviouslyPlayed: state.core.storedPlaybackTime !== null,
    };
}

export default connect<ResumePlaybackProps, any, void>(mapStateToProps)(ResumePlayback);
